/**
 * 配置管理侧边栏组件
 */
import React from 'react';
import { Layout, Menu } from 'antd';
import {
    BarChartOutlined,
    RocketOutlined,
    SettingOutlined,
    DollarOutlined,
    TableOutlined,
    AppstoreOutlined,
    RobotOutlined
} from '@ant-design/icons';
import { METRIC_DIMENSIONS, getIconComponent } from '../constants/componentLabels';

const { Sider } = Layout;

interface ConfigSidebarProps {
    selectedKey: string;
    onSelect: (key: string) => void;
    openKeys: string[];
    onOpenChange: (keys: string[]) => void;
}

const MENU_ITEMS = [
    {
        key: 'scoring',
        icon: <BarChartOutlined />,
        label: '评分模型配置',
        children: METRIC_DIMENSIONS.map(d => ({
            key: d.key,
            label: d.label,
            icon: getIconComponent(d.iconType)
        }))
    },
    {
        key: 'logistics',
        icon: <RocketOutlined />,
        label: '物流费用配置',
        children: [
            { key: 'fba-fees', label: 'FBA费率配置', icon: <DollarOutlined /> }
        ]
    },
    {
        key: 'system',
        icon: <SettingOutlined />,
        label: '系统高级配置',
        children: [
            { key: 'structure-overview', label: '配置结构总览', icon: <TableOutlined /> },
            { key: 'comparison', label: '预设对比', icon: <AppstoreOutlined /> },
            { key: 'global-ai-config', label: '全局AI配置', icon: <RobotOutlined /> }
        ]
    }
];

export const ConfigSidebar: React.FC<ConfigSidebarProps> = ({
    selectedKey,
    onSelect,
    openKeys,
    onOpenChange
}) => {
    return (
        <Sider width={260} theme="light" style={{ borderRight: '1px solid #f0f0f0' }}>
            <Menu
                mode="inline"
                selectedKeys={[selectedKey]}
                openKeys={openKeys}
                onOpenChange={(keys) => onOpenChange(keys as string[])}
                onClick={({ key }) => onSelect(key)}
                style={{ height: '100%', borderRight: 0 }}
                items={MENU_ITEMS}
            />
        </Sider>
    );
};
